import { CardLeafProps } from './types'

import * as S from './styles'

const CardLeaft = ({ ...props }: CardLeafProps) => {
  return (
    <S.CardLeaf>
      <S.Figure>
        <img src={props.image} title={props.metaImgTitle} alt={props.metaImgAlt} />
      </S.Figure>
      <S.Content>
        {props.time && <S.Time>{props.time}</S.Time>}
        <h3 title={props.metaTitle}>{props.title}</h3>
        <S.AuthorWrap>
          {props.author && (
            <S.Avatar size="xs" name={props.author}>
              {props.photo && (
                <img
                  src={`${props.photo}`}
                  alt={props.author}
                />
              )}
            </S.Avatar>
          )}

          <S.Author>{props.author}</S.Author>
        </S.AuthorWrap>
      </S.Content>
    </S.CardLeaf>
  )
}
export default CardLeaft
